import MessagingChannelProfilePic from './MessagingChannelProfilePic';

export default MessagingChannelProfilePic;
